import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const Tools = observer(class Tools extends React.Component {
  render() {
    const { translation } = this.props;

    return(
      <div className="page">
        <ul className="app-tools wrap">
          <li>
            <button
              className="access-toggle btn--outline"
              onClick={this.props.refresh}
            >
              <icons.iconRefresh />
              <span className="meta">{translation.refresh}</span>
            </button>
          </li>
        </ul>
      </div>
    );
  }
})

export default translate('Tools')(Tools);



// WEBPACK FOOTER //
// ./src/app/components/Common/Tools.js